//
import "./components/header.js";
import "./components/footer.js";

//
// import "./components/checart.js";
import "./components/script.js";

//
import "./components/shop.js";
import "./components/product-row.js";
import "./components/product.js";

// Время пользователя на сайте
// import "./components/visit-time.js";

// Скрипт инпута ввода количества
import "./components/qty-input.js";

// Скрипт инпута ввода количества
// import "./components/glightbox.js";

// Скрипт закрытия уведомлений woocommerce
// import "./components/closeWcNotice.js";

// Реализация аккордеона Грекова
import "./components/page-banner.js";

// Реализация аккордеона Грекова
import "./components/gacardeon.js";
